import { useOutletContext } from 'react-router-dom';
import type { UsePartnerReferralsResult } from '../../hooks/usePartnerReferrals';
import type { MyReferralProgramAccess } from '../../hooks/useMyReferralProgramAccess';

/**
 * What the portal layout hands every tab: the shared referral data (loaded
 * once for all tabs) plus the fee switch. `hideFees` is useAuth().hideCommissions;
 * when true no fee figure renders anywhere in the portal.
 */
export interface PartnerPortalContext extends UsePartnerReferralsResult {
  hideFees: boolean;
  /** The "My referral program" gate (the desk of a program this company operates). */
  myProgram?: MyReferralProgramAccess;
}

export function usePartnerPortalContext(): PartnerPortalContext {
  return useOutletContext<PartnerPortalContext>();
}

/** What the "My referral program" route reads from the layout (present for referrer-side and desk-only viewers alike). */
export interface MyProgramOutletContext {
  myProgram?: MyReferralProgramAccess;
}
